module.exports = __webpack_public_path__ + "static/img/401.f6cbc4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/401.png
// module id = GG6c
// module chunks = 52